export enum GENDER {
	MALE = 'male',
	FEMALE = 'female',
}

export enum AGE_IMAGE_VARIANT {
	A = 'a',
	C = 'c',
	D = 'd',
	E = 'e',
	F = 'f',
	MALE_V0 = 'maleV0',
	MALE_V1 = 'maleV1',
	// MALE_BB = 'maleBB',
	// FEMALE_BB = 'femaleBB',
}

export enum DURATION {
	MINIMUM = 'minimum',
	NORMAL = 'normal',
	MAXIMUM = 'maximum',
}

export enum WEB_PLATFORM {
	FACEBOOK_WEB = 'facebook_web',
	PINTEREST_INT = 'pinterest_int',
	TIKTOK_WEB = 'tiktok_web',
}

export enum SURVEY_CONFIG {
	TEST = 'test',
	SHORT = 'short',
	DEFAULT_CONFIG = 'defaultConfig',
	ADQ = 'AdQ',
	ACADEMY = 'academy',
	ACADEMYV2 = 'academyV2',
	ACADEMYV3 = 'academyV3',
	ACADEMYV3FSV2 = 'academyV3FsV2',
	WALKING = 'walking',
	PILATES = 'pilates',
}

export interface IExtraDataPromocode {
	promocode: string;
	timestamp: number;
}
